
























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class TextButton extends Vue {
    @Prop() private userConfigColor! : string;

    setIsSelectTextVisible(){
        this.$emit("setIsSelectTextVisible");
    }
}
